import React, {useState} from 'react'
import {Checkbox, Modal, notification} from "antd";
import {Formik} from "formik";
import {FormattedMessage, useIntl} from "react-intl";
import apiClient from "../services/api";
import {SuccessIcon} from "../config/icons";
import {axiosErrorHandler} from "./platform/utils";
import Field from "./platform/form/Field";
import {Button} from "./platform/buttons/Button";
import useCurrentUser from "./platform/hooks/useCurrentUser";
import usePlatformParams from "./platform/hooks/usePlatformParams";

const CustomerContractModal = () => {
  const user = useCurrentUser()
  const customer = user?.customer
  const [loading, setLoading] = useState(false);
  const intl = useIntl()
  const platformParams = usePlatformParams()
  const showExport = platformParams.allows(platformParams.gates.SHOW_CUSTOMER_CONTRACT)

  if(!showExport) {
    return null
  }

  return (
    <Modal width={1000} title="" visible footer={null}>
      <Formik
        initialValues={{contract:false, contract2:false}}
        onSubmit={values => {
          setLoading(true)
          const date = values.contract ? new Date() : null
          apiClient
            .patch(`/api/customers/${customer.id}/dataroom`, {
              dateContract: date,
              updateMetadata: {
                contractDateIED2: values.contract2 ? new Date() : null,
              },
            })
            .then(() => {
              setLoading(false)
              notification.success({
                message: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({ id: 'global.operation_success' }),
                    }}
                  />
                ),
                placement: 'bottomRight',
                icon: <SuccessIcon style={{ color: '#0C9F07' }} />,
              })
              // reload page
              window.location.reload()
            })
            .catch(err => {
              setLoading(false)
              axiosErrorHandler(err)
            })
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <div className={'fg'}>
              <h3><strong>Terms of Use:</strong></h3>
              <iframe title="Privacy 1" src="/privacy-ied.html" width="100%" height="200" />
              <Field
                label={''}
                name={'contract'}
                style={{width: 25}}
                onChange={(e: any) => setFieldValue("contract", e.target.checked)}
                component={Checkbox}
                append={<span>*<FormattedMessage id={'global.read_and_agree'} /></span>}
              />
              <iframe title="Privacy 2" src="/privacy-ied2.html" width="100%"  />
              <Field
                label={''}
                name={'contract2'}
                style={{width: 25}}
                onChange={(e: any) => setFieldValue("contract2", e.target.checked)}
                component={Checkbox}
                append={<span><FormattedMessage id={'global.read_and_agree'} /></span>}
              />
            </div>
            <div className={"text-right"}>
              <Button loading={loading} color={'primary'} disabled={!values?.contract} onClick={() => handleSubmit()}>
                <FormattedMessage id={"global.save"} />
              </Button>
            </div>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default CustomerContractModal
